import { useRef, useEffect } from 'react';
import { Reveal } from 'react-awesome-reveal';
import classnames from 'classnames';
import fadeInLeft from 'components/animations/fadeInLeft';
import ExperienceARButton from 'components/experience-ar-button';
import lang from 'constants/lang';
import translations from 'constants/artwork';
import styles from './Details.module.scss';

function Details({ page, artwork, artworkOrdering, timecodes, setPage }) {
  const videoRef = useRef(null);
  const currentIndex = artworkOrdering.indexOf(artwork);
  // const nextIndex = currentIndex === artworkOrdering.length - 1 ? 0 : currentIndex + 1;
  // const nextIsInterview = currentIndex < artworkOrdering.length - 1 && artworkOrdering[currentIndex + 1] === 'interview';
  // const nextIsARGallery = currentIndex < artworkOrdering.length - 1 && artworkOrdering[currentIndex + 1] === 'argallery';

  useEffect(() => {
    if (page.startsWith('/artwork/interview-')) {
      let timecode = parseInt(page.replace('/artwork/interview-', ''));
      if (isNaN(timecode)) {
        timecode = null;
      } else if (videoRef.current) {
        videoRef.current.currentTime = timecode;
      }
    }
  }, [page, videoRef]);

  if (artwork === 'argallery') {
    return (
      <div className={ styles.container }>
        <div className={ styles.wrapper }>
          <div className={ styles.arContent }>
            <div className={ styles.arTitle }>
              <div className={ styles.arTitle1 }>{ translations['argallery-title1'] }</div>
              <div className={ styles.arTitle2 }>
                <img src={ `${process.env.PUBLIC_URL}/images/ar.svg` } className={ styles.ar } alt="AR" />
                <span>{ translations['argallery-title2'] }</span>
              </div>
            </div>

            <div className={ styles.arMain }>
              <div className={ styles.arDesc }>
                <p dangerouslySetInnerHTML={{ __html: translations['argallery-desc'] }} />
              </div>
              <div className={ styles.arInstruction }>
                <div className={ styles.arInstructionStep }>
                  <div className={ styles.arInstructionStepNumber }>
                    <img src={ `${process.env.PUBLIC_URL}/images/1.svg` } alt="1" />
                  </div>
                  <div className={ styles.arInstructionStepText }>{ translations['argallery-step1'] }</div>
                </div>
                <div className={ styles.arInstructionStep }>
                  <div className={ styles.arInstructionStepNumber }>
                    <img src={ `${process.env.PUBLIC_URL}/images/2.svg` } alt="2" />
                  </div>
                  <div className={ styles.arInstructionStepText }>{ translations['argallery-step2'] }</div>
                </div>
                <div className={ styles.arInstructionStep }>
                  <div className={ styles.arInstructionStepNumber }>
                    <img src={ `${process.env.PUBLIC_URL}/images/3.svg` } alt="3" />
                  </div>
                  <div className={ styles.arInstructionStepText }>{ translations['argallery-step3'] }</div>
                </div>
                <a href="https://metaparadeworldtour.com" target="_blank" rel="noopener noreferrer" className={ classnames(styles.arInstructionCtaLink, styles[lang]) }>
                  <div className={ styles.arInstructionCta }>
                    <div className={ classnames(styles.arInstructionCtaText1, styles[lang]) }>{ translations['argallery-cta'] }&nbsp;</div>
                    <div className={ styles.arInstructionCtaText2 }>META-PARADE</div>
                    <div className={ styles.arInstructionCtaAr }>
                      <img src={ `${process.env.PUBLIC_URL}/images/ar.svg` } className={ classnames(styles.ar, styles[lang]) } alt="AR" />
                    </div>
                    <div className={ styles.arInstructionCtaText2 }>{ translations['argallery-cta-gallery'] }</div>
                  </div>
                  <div className={ classnames(styles.arInstructionCtaQrCode, styles[lang]) }>
                    <img src={ `${process.env.PUBLIC_URL}/images/qrcode.png` } alt=">" />
                  </div>
                  <div className={ styles.arrow }>
                    <img src={ `${process.env.PUBLIC_URL}/images/arrow-right.svg` } alt=">" />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={ styles.container }>
      <div className={ styles.wrapper }>
        <p dangerouslySetInnerHTML={{ __html: translations[artwork] }} />
        <ExperienceARButton
          setPage={ setPage }
          className={ styles.experience }
        />

        {
          artwork !== 'interview' && (
            <Reveal keyframes={ fadeInLeft } duration={ 1000 } triggerOnce>
              <div
                className={ classnames(styles.viewNext, currentIndex === artworkOrdering.length - 1 && styles.inactive) }
                onClick={ () => setPage(`/artwork/interview-${timecodes[artwork]}`) }
              >
                <div className={ classnames(styles.viewNextText, styles.viewInterviewText) }>{ translations.viewInterview }</div>
                <div className={ classnames(styles.arrow, styles.arrowMiddle) }>
                  <Reveal keyframes={ fadeInLeft } delay={ 500 } duration={ 1000 } triggerOnce>
                    <img src={ `${process.env.PUBLIC_URL}/images/arrow-right.svg` } alt=">" />
                  </Reveal>
                </div>
              </div>
            </Reveal>
          )
        }
        {/* {
          !nextIsInterview && !nextIsARGallery && (
            <Reveal keyframes={ fadeInLeft } duration={ 1000 } triggerOnce>
              <div
                className={ classnames(styles.viewNext, currentIndex === artworkOrdering.length - 1 && styles.inactive) }
                onClick={ () => currentIndex !== artworkOrdering.length - 1 && setPage(`/artwork/${artworkOrdering[nextIndex]}`) }
              >
                  <div className={ styles.viewNextText }>
                    { translations.viewNext }
                    <br />
                  </div>
                <div className={ classnames(styles.arrow) }>
                  <Reveal keyframes={ fadeInLeft } delay={ 500 } duration={ 1000 } triggerOnce>
                    <img src={ `${process.env.PUBLIC_URL}/images/arrow-right.svg` } alt=">" />
                  </Reveal>
                </div>
              </div>
            </Reveal>
          )
        } */}

        {
          artwork === 'interview' && (
            <div className={ styles.interview }>
              <div>
                <video autoPlay loop muted playsInline controls ref={ videoRef }>
                  <source
                    src={ `${process.env.PUBLIC_URL}/videos/interview-${lang}.mp4` }
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
}

export default Details;